/**
 * 讯石售货机收银台。电脑二维码和手机按钮先打开 openauth。
 * 授权回来只为了用 code 换 tradeNO 并调用 tradePay，支付宝内不展示金额卡片。
 */
import { executeYwzfPay, fetchYwzfCashierPage } from '@/api/api'

const HOST_REDIRECT = 'https://ys.ywzf188.cn/m/redirect.html?url='

export function inAlipay () {
  return /AlipayClient/i.test((navigator && navigator.userAgent) || '')
}

/** 与直付通收银台同一口径：支付宝内和手机浏览器都不算出码端。 */
export function isDesktopBrowser () {
  if (typeof navigator === 'undefined' || inAlipay()) return false
  return !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(navigator.userAgent || '')
}

export function formatCountdown (leftMs) {
  const s = Math.max(0, Math.floor(Number(leftMs) / 1000))
  const m = Math.floor(s / 60)
  const sec = s % 60
  return (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec
}

function usableCode (code) {
  if (code == null) return ''
  const text = String(code).trim()
  if (!text || text === 'undefined' || text === 'null') return ''
  return text
}

/** redirect.html 在没有授权码时会拼上字面量 undefined，不能再跳一次授权。 */
export function authRejected (routeQuery) {
  return collectRawCodes(routeQuery).some((text) => text === 'undefined' || text === 'null')
}

function collectRawCodes (routeQuery) {
  const found = []
  const q = routeQuery || {}
  if (q.code != null) found.push(String(q.code).trim())
  if (q.auth_code != null) found.push(String(q.auth_code).trim())
  if (typeof location === 'undefined') return found
  const search = new URLSearchParams(location.search)
  found.push(search.get('code') || '', search.get('auth_code') || '')
  const hash = location.hash || ''
  const idx = hash.indexOf('?')
  if (idx >= 0) {
    const hp = new URLSearchParams(hash.slice(idx + 1))
    found.push(hp.get('code') || '', hp.get('auth_code') || '')
  }
  return found
}

export function readAuthCode (routeQuery) {
  const q = routeQuery || {}
  const fromRoute = usableCode(q.code) || usableCode(q.auth_code)
  if (fromRoute) return fromRoute
  const search = new URLSearchParams(location.search)
  const fromSearch = usableCode(search.get('code')) || usableCode(search.get('auth_code'))
  if (fromSearch) return fromSearch
  const hash = location.hash || ''
  const idx = hash.indexOf('?')
  if (idx < 0) return ''
  const hp = new URLSearchParams(hash.slice(idx + 1))
  return usableCode(hp.get('code')) || usableCode(hp.get('auth_code'))
}

export function cleanPageUrl () {
  const u = new URL(location.href)
  if (u.hash && u.hash.indexOf('?') >= 0) {
    const parts = u.hash.split('?')
    const p = new URLSearchParams(parts[1] || '')
    p.delete('code')
    p.delete('auth_code')
    p.delete('state')
    const rest = p.toString()
    u.hash = rest ? parts[0] + '?' + rest : parts[0]
    return u.toString()
  }
  u.searchParams.delete('code')
  u.searchParams.delete('auth_code')
  u.searchParams.delete('state')
  return u.toString()
}

/** 与当面付一致：外链按钮用扫码容器打开裸 openauth，不用 20000067。 */
export function alipayScheme (appId) {
  return 'alipayqr://platformapi/startapp?saId=10000007&qrcode=' + encodeURIComponent(authUrl(appId))
}

export function authUrl (appId) {
  const back = HOST_REDIRECT + encodeURIComponent(cleanPageUrl())
  return 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=' + encodeURIComponent(appId || '')
    + '&scope=auth_user&redirect_uri=' + encodeURIComponent(back) + '&state=alipay'
}

export async function loadPageContext (orderId, token) {
  const ctx = await fetchYwzfCashierPage(orderId, token)
  if (!ctx) throw new Error('页面加载失败')
  return ctx
}

export async function requestExecute (orderId, token, code) {
  const d = await executeYwzfPay(orderId, token, code)
  if (!d) throw new Error('网络异常')
  return d
}

export function parseTradeParams (raw) {
  if (!raw) return null
  try {
    const params = typeof raw === 'string' ? JSON.parse(raw) : raw
    if (params && params.trade_no && !params.tradeNO) params.tradeNO = params.trade_no
    return params && params.tradeNO ? params : null
  } catch (e) {
    return null
  }
}

export function ensureAlipayJsapi () {
  if (window.ap && window.ap.tradePay) return Promise.resolve()
  return new Promise((resolve) => {
    const existed = document.querySelector('script[data-ywzf-alipayjs]')
    if (existed) {
      existed.addEventListener('load', () => resolve(), { once: true })
      existed.addEventListener('error', () => resolve(), { once: true })
      return
    }
    const script = document.createElement('script')
    script.src = 'https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js'
    script.async = true
    script.dataset.ywzfAlipayjs = '1'
    script.onload = () => resolve()
    script.onerror = () => resolve()
    document.head.appendChild(script)
  })
}
